<template>
    <alert-modal no-button ref="modal" @shown="input.focus()">
        <template #modallabel>
            <h3 class="modal-title">修改身份證字號</h3>
        </template>
        <div class="max-w:400 w:full mx:auto f:16 t:left {mt:16}>div+div">
            <div>
                <img alt="" class="max-w:full" :src="`${prefix}asset/image/ID.png`" />
            </div>
            <div class="t:center">
                請根據您的身份證資料，填寫以下欄位進行驗證。
            </div>
            <div>
                <label class="form-label required">身份證字號</label>
                <input class="form-control {d:none}+div {d:block}:focus-within+div" :id="id" placeholder="請輸入身份證字號" ref="input" type="text" v-model.trim="form.id" />
                <div class="mt:4">
                    <div class="error-msg error" v-if="form.id && !form.id.match(/[A-Z][12]\d{8}/)">身份證字號格式有誤，請確認</div>
                    <div class="info-msg" v-else>根據身份證上「統一編號」填寫</div>
                </div>
            </div>
            <div>
                <label class="form-label required">發證日期</label>
                <div class="row {d:none}+div {d:block}:focus-within+div {mx:-6}@<sm {px:6}>.col-4@<sm">
                    <div class="col-4">
                        <decorator-input class="form-control" :decorator="(v) => `${v} 年`" inputmode="numeric" placeholder="民國" type="text" v-model="form.year"></decorator-input>
                    </div>
                    <div class="col-4">
                        <decorator-input class="form-control" :decorator="(v) => `${v} 月`" inputmode="numeric" placeholder="月" type="text" v-model="form.month"></decorator-input>
                    </div>
                    <div class="col-4">
                        <decorator-input class="form-control" :decorator="(v) => `${v} 日`" inputmode="numeric" placeholder="日" type="text" v-model="form.date"></decorator-input>
                    </div>
                </div>
                <div class="mt:4">
                    <div class="info-msg">根據身份證上「發證日期」填寫</div>
                </div>
            </div>
            <div>
                <label class="form-label required">發證地點</label>
                <select2 :options="cityList" placeholder="請輸入發證地點" v-model="form.city"></select2>
            </div>
            <div>
                <label class="form-label required">發證類型</label>
                <select2 :options="typeList" placeholder="請選擇" v-model="form.type"></select2>
            </div>
        </div>
        <template #modalfooter>
            <div class="modal-footer">
                <button class="btn btn-outline-secondary" data-bs-dismiss="modal" type="button">取消</button>
                <button class="btn btn-primary" @click="submit" :disabled="!available_identity" type="button">驗證</button>
            </div>
        </template>
    </alert-modal>
</template>

<script setup>
    const available_identity = computed(() => form.value.id?.match(/[A-Z][12]\d{8}/) && identity_date.value && form.value.city && form.value.type);

    const cityList = [
        { value: "10001", label: "北縣" },
        { value: "10002", label: "宜縣" },
        { value: "10003", label: "桃縣" },
        { value: "10004", label: "竹縣" },
        { value: "10005", label: "苗縣" },
        { value: "10006", label: "中縣" },
        { value: "10007", label: "彰縣" },
        { value: "10008", label: "投縣" },
        { value: "10009", label: "雲縣" },
        { value: "10010", label: "嘉縣" },
        { value: "10011", label: "南縣" },
        { value: "10012", label: "高縣" },
        { value: "10013", label: "屏縣" },
        { value: "10014", label: "東縣" },
        { value: "10015", label: "花縣" },
        { value: "10016", label: "澎縣" },
        { value: "10017", label: "基市" },
        { value: "10018", label: "竹市" },
        { value: "10020", label: "嘉市" },
        { value: "09007", label: "連江" },
        { value: "09020", label: "金門" },
        { value: "63000", label: "北市" },
        { value: "64000", label: "高市" },
        { value: "65000", label: "新北市" },
        { value: "66000", label: "中市" },
        { value: "67000", label: "南市" },
        { value: "68000", label: "桃市" }
    ];

    const form = ref({});

    const id = nextId();

    const identity_date = computed(() => {
        if (form.value.year && form.value.month && form.value.date) {
            return [
                form.value.year < 10 ? `00${form.value.year}` : (form.value.year < 100 ? `0${form.value.year}` : form.value.year),
                form.value.month < 10 ? `0${form.value.month}` : form.value.month,
                form.value.date < 10 ? `0${form.value.date}` : form.value.date
            ].join("");
        }
    });

    const input = ref();

    const modal = ref();

    const prefix = inject("prefix");

    const typeList = [
        { value: "0", label: "未領" },
        { value: "1", label: "初發" },
        { value: "2", label: "補發" },
        { value: "3", label: "換發" }
    ];

    const emit = defineEmits(["submit"]);

    const hide = () => {
        modal.value.hide();
    };

    const show = () => {
        form.value.id = "";
        form.value.year = "";
        form.value.month = "";
        form.value.date = "";
        form.value.city = "";
        form.value.type = "";

        modal.value.show();
    };

    const submit = () => {
        emit("submit", {
            id: form.value.id,
            date: identity_date.value,
            city: form.value.city,
            type: form.value.type
        });
    };

    defineExpose({ hide, show });

    watch(() => form.value.id, () => {
        form.value.id = form.value.id?.match(/^[a-zA-Z]\d{0,9}/)?.[0].toUpperCase();
    });

    watch(() => form.value.year, () => {
        setTimeout(() => form.value.year = form.value.year.replaceAll(/[^\d]/g, "").substring(0, 4));
    });

    watch(() => form.value.month, () => {
        setTimeout(() => {
            let month = form.value.month.replaceAll(/[^\d]/g, "");

            if (month) {
                if (month < 1) {
                    month = "1";
                } else if (month > 12) {
                    month = "12";
                }
            }

            form.value.month = month;
        });
    });

    watch(() => form.value.date, () => {
        setTimeout(() => {
            let date = form.value.date.replaceAll(/[^\d]/g, "");

            if (date) {
                if (date < 1) {
                    date = "1";
                } else if (date > 31) {
                    date = "31";
                }
            }

            form.value.date = date;
        });
    });
</script>
